import { render, staticRenderFns } from "./ApprovalRequestDialog.vue?vue&type=template&id=c0a2e4a4&scoped=true&"
import script from "./ApprovalRequestDialog.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRequestDialog.vue?vue&type=style&index=0&id=c0a2e4a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2e4a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer})
